import { config } from "./config";

export default function Fetcher ( call, feed ) {
  const verbose = false;

  return new Promise ( ( resolve, reject ) => {

    // abort in case of empty call
    if ( call == null || call === {} ) {
      reject({ type:'error' , msg:'no call data aborting' });
    }

    // build form data request from call object iteration.
    // multipart compatible.
    const formData = new FormData();
    Object.keys( call ).forEach( k => {
      formData.append( k, call[k] );
    });

    // fetch.
    fetch( config.api[ feed ], {
      method: 'POST',
      body: formData

      // get response data.
    }).then( res => {
      return res.json();

      // check api response status and return data.
    }).then( data => {

      if (verbose) { console.log( data ); }

      if ( data.status === 'ok' ) {
        resolve( data.result );

      } else {
        // not ok return error object
        reject({ type : 'error', msg : data.response });
      }

    })
    .catch( err => {
      console.log( err );
      reject({ type : 'error', msg : err.message });
    });
  });
}
